import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

export default function BrandLogoCarousel() {    
    const brandLogos = [
        {
            name: "Billi",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/billi-logo.png",
            alt: "Billi logo displayed in a dark blue gradient wordmark, representing Billi’s premium boiling, chilled, and sparkling water systems for commercial and residential spaces."
        },
        {
            name: "Franke",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/franke-logo.png",
            alt: "Franke logo shown in bold white lettering on black rectangular blocks, representing Franke’s commercial sinks, kitchen systems, and bathroom solutions."
        }, 
        {
            name: "Goldair",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/goldair-logo.png",
            alt: "Goldair logo in blue text with a stylised wave accent, representing Goldair’s heating, cooling, and ventilation solutions for commercial and residential environments."
        },
        {
            name: "Caroma",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/caroma-logo.png",
            alt: "Caroma logo with the tagline 'Made For Life' in black text, representing Caroma’s Australian-designed bathroom fixtures, sanitaryware, and water-efficient commercial bathroom solutions."
        },
        {
            name: "Methven",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/methven-logo.png",
            alt: "Methven logo in black text, representing Methven’s innovative tapware, shower, and bathroom solutions."
        },
        {
            name: "American Standard",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/american-standard-logo.png",
            alt: "American Standard logo featuring the brand name written in a bold black script font on a white background, representing a leading manufacturer of commercial bathroom and plumbing products."
        },
       
        {
            name: "Puretec",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/puretec-perfecting-water-logo.png",
            alt: "Puretec logo featuring a water droplet icon and the tagline 'Perfecting Water,' representing Puretec’s water filtration and treatment systems for commercial and residential use."
        },
        {
            name: "St Michel and Zenith",
            url: "https://hncnzwww.blob.core.windows.net/www/img/suppliers/st.michel-logo.png",
            alt: "St. Michel logo in modern black lowercase typography, representing St. Michel’s contemporary bathroom vanities and storage solutions."
        }
        
        
    ];
    // Embla autoplay plugin instance
    const autoplay = Autoplay({ delay: 2000, stopOnInteraction: false });

    return (
        <div className="w-full py-16 relative overflow-hidden bg-white">          
            <div className="max-w-12xl mx-auto px-4 ">
                {/* <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-10 md:mb-16 lg:mb-24">Our Trusted Brands</h2> */}
                <Carousel
                    opts={{ align: "start", loop: true, slidesToScroll: 1 }}
                    plugins={[autoplay]}
                >
                    <CarouselContent>
                        {brandLogos.map((logo, idx) => (
                            <CarouselItem
                                key={idx}
                                className="flex flex-col items-center justify-center px-6 basis-1/2 md:basis-1/3 lg:basis-1/5"
                            >
                                <img
                                    src={logo.url}
                                    alt={logo.alt}
                                    className="h-7 w-auto md:h-10 lg:h-12 object-contain transition duration-300   m-0"
                                    loading="lazy"
                                />
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious />
                    <CarouselNext />
                </Carousel>
            </div>
        </div>
    );
}